<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-07-08 17:45:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-11-11 17:06:54
-->
<template>
  <div :class="[{ activity_list_con_notitle: hideTitle }, 'activity_list_con']">
    <p class="title_con" v-if="!hideTitle">
      {{ title }}
    </p>
    <ul class="activity_list_group">
      <li
        v-for="(item, index) in showListData"
        :key="index"
        class="activity_list_item"
        @click="handleClickGoods(item)"
      >
        <van-row type="flex" gutter="20">
          <div class="activity_img_con">
            <div class="yellowFlag" v-if="fromCom == 'groupBuy'">
              2人成团
              <i></i>
              <i class="last_i"></i>
            </div>
            <img
              class="full_img"
              :src="item.imgUrl ? item.imgUrl : $root.defaultImg"
              alt=""
            />
            <div
              class="clock_con"
              v-if="item.SaleStatusId == 0 || item.SaleStatusId == 1"
            >
              {{ item.SaleStatusId == 0 ? "距结束" : "距开始" }}
              <van-count-down :time="item.time" />
            </div>
          </div>
          <div class="activity_right_con">
            <div>
              <p class="font-32 m-tb-10">{{ item.TicketName }}</p>
              <!-- <p class="font-26">{{ item.GoodsDetailExplain }}</p> -->
              <p class="price_con m-t-20">
                ￥{{ item.GrouponPrice }}
                <span class="c-lightgrey" v-if="item.MarketPrice"
                  >￥{{ item.MarketPrice }}</span
                >
              </p>
            </div>

            <div class="activity_bottom_con">
              <p class="c-lightgrey font-20 w-60%" style="position: relative">
                <span class="sale_num_con"
                  >{{ fromCom == "timeLimit" ? "已抢" : "已拼" }}
                  {{ item.allSaleNumber }}</span
                >
                <van-progress
                  :percentage="item.percentage"
                  :show-pivot="false"
                  stroke-width="12"
                  color="#dcca9f"
                  track-color="#EFE7D9"
                />
                <span class="sale_per_con">{{ item.percentage }}%</span>
              </p>

              <p class="flex-s-0">
                <van-button
                  v-if="fromCom == 'timeLimit'"
                  size="small"
                  color="var(--tc)"
                  round
                  >{{ handleSetBtnName(item.SaleStatusId) }}</van-button
                >
                <van-button
                  v-if="fromCom == 'groupBuy'"
                  size="small"
                  color="var(--tc)"
                  round
                  >发起拼团</van-button
                >
              </p>
            </div>
          </div>
        </van-row>
      </li>
    </ul>
  </div>
</template>

<script>
import { getProductList } from "@/api/goods";
import { handleLocalStorage } from "@/utils";
export default {
  name: "AllList",
  props: {
    fromCom: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      showListData: [],
    };
  },
  created() {
    this.initList();
  },
  mounted() {},
  methods: {
    initList() {
      this.dataList.map((item) => {
        const ticketItem = item.DrawTicketItems && item.DrawTicketItems[0];
        // 产品列表图片
        const imgArr = ticketItem.Claims;
        if (imgArr instanceof Array && imgArr.length > 0) {
          const imgItem = imgArr.find((subItem) => subItem.TypeId === 0);
          if (imgItem) {
            item.imgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
          }
        }
        if (ticketItem.SaleStatusId == 1) {
          let timeNum =
            new Date(item.StartTime.replace(/-/g, "/")) - new Date();

          item.time = timeNum;
        } else if (ticketItem.SaleStatusId == 0) {
          let timeNum = new Date(item.EndTime.replace(/-/g, "/")) - new Date();

          item.time = timeNum;
        }
        item.SaleStatusId = ticketItem.SaleStatusId;
        item.TicketName = ticketItem.TicketName;
        item.GrouponPrice = ticketItem.GrouponPrice;
        item.MarketPrice = ticketItem.MarketPrice;
        const realSaleNumber = ticketItem.AddupStock - ticketItem.RealtimeStock;
        item.allSaleNumber = realSaleNumber + ticketItem.VirtualSaleNumber || 0;
        // item.allSaleNumber = 23;
       item.percentage =ticketItem.ReceiveRate;
      });
      this.showListData = this.dataList;
    },
    handleSetBtnName(saleStatusId) {
      // console.log(item);
      if (saleStatusId == 0) {
        return "立即抢购";
      } else if (saleStatusId == 3) {
        return "已抢完";
      } else if (saleStatusId == 1) {
        return "未开始";
      } else if (saleStatusId == 2) {
        return "已结束";
      }
    },
    handleClickGoods(item) {
      if (this.fromCom == "timeLimit") {
        handleLocalStorage.set("flashGoodsInfo", item);
        //抢购
        this.$router.push({
          name: "FlashSalePage",
          params: { id: item.Id },
          query: {
            fromPage: "flash",
          },
        });
      } else {
        //拼团
        this.$router.push({
          name: "FlashSalePage",
          params: { id: item.Id },
          query: {
            fromPage: "group",
          },
          // query: { id: item.GoodsId, type: item.GoodType, VpnCode: vpnCode },
        });
        // this.$router.push({
        //   name: "GroupBuyPage",
        //   // query: { id: item.GoodsId, type: item.GoodType, VpnCode: vpnCode },
        // });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.activity_list_con {
  background: linear-gradient(180deg, #dcc494 0%, #efe7d9 100%, #f7f5f6 100%);
  margin: 30px;
  border-radius: 16px;
  padding: 30px;
  &.activity_list_con_notitle {
    padding: 0;
    background: none;
  }
  .title_con {
    color: #fff;
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 32px;
  }
  .activity_list_group {
    .activity_list_item {
      background: #fff;
      border-radius: 16px;
      margin-bottom: 15px;
      .activity_img_con {
        flex-shrink: 0;
        position: relative;
        width: 240px;
        height: 240px;
        img {
          border-radius: 16px 0 0 16px;
        }
        .yellowFlag {
          position: absolute;
          top: 0;
          left: 0;
          box-sizing: border-box;
          padding: 5px 10px 5px 12px;
          color: #fff;
          font-size: 26px;
          background: linear-gradient(
            180deg,
            rgba(255, 218, 135, 1) 0%,
            rgba(255, 186, 67, 1) 100%
          );
          i {
            position: absolute;
            right: -12px;
            top: -2px;
            z-index: 1;
            width: 0;
            height: 0;
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
            border-bottom: 10px solid #ffcd6c;
            transform: rotate(-45deg);
            &.last_i {
              top: unset;
              bottom: -2px;
              border-bottom: none;
              border-top: 10px solid #ffc459;
              transform: rotate(45deg);
            }
          }
        }
        .clock_con {
          position: absolute;
          left: 0;
          bottom: 0;
          right: 0;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 0 0 0 16px;
          color: var(--tc);
          font-size: 22px;
          .van-count-down {
            font-size: 13px;
            color: var(--tc);
            margin-left: 5px;
          }
        }
      }
      .activity_right_con {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 15px;
        .activity_bottom_con {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .sale_num_con {
            position: absolute;
            left: 10px;
            top: 1px;
            z-index: 2;
            color: rgb(185, 141, 69);
          }
          .sale_per_con {
            position: absolute;
            right: 10px;
            top: 1px;
            z-index: 2;
            color: rgb(185, 141, 69);
          }
        }
        .price_con {
          color: var(--tc);
          font-size: 32px;
          span {
            text-decoration: line-through;
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>
